export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-700italic-cdb52a1cb0836b14f5822d1d986656f5.eot";